const ALLOWED = new Set(['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'h3', 'code']);

function escapeText(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function assistantHtml(input: string): string {
  let html = String(input || '');
  html = html.replace(/<\s*(script|style)[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '');
  html = html.replace(/<!--[\s\S]*?-->/g, '');
  html = html.replace(/<\/?([a-z0-9]+)(\s[^>]*)?\/?>/gi, (match, tag) => {
    const name = String(tag || '').toLowerCase();
    if (!ALLOWED.has(name)) return '';
    if (match.startsWith('</')) return `</${name}>`;
    if (name === 'br') return '<br>';
    return `<${name}>`;
  });
  html = html.replace(/\n+/g, '').trim();
  if (html && /<\s*(p|h3|ul|ol|li)\b/i.test(html)) return html;
  const raw = String(input || '')
    .replace(/<\s*(script|style)[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, ' ')
    .replace(/<[^>]+>/g, '');
  const lines = raw.split(/\n/).map((line) => line.trim()).filter(Boolean).slice(0, 12);
  if (!lines.length) return '';
  const item = (line: string, mark: RegExp) => escapeText(line.replace(mark, ''));
  if (lines.length > 1 && lines.every((line) => /^\d+[.)]\s+/.test(line))) {
    return `<ol>${lines.map((line) => `<li>${item(line, /^\d+[.)]\s+/)}</li>`).join('')}</ol>`;
  }
  if (lines.length > 1 && lines.every((line) => /^[-•]\s+/.test(line))) {
    return `<ul>${lines.map((line) => `<li>${item(line, /^[-•]\s+/)}</li>`).join('')}</ul>`;
  }
  return lines.map((line) => `<p>${escapeText(line)}</p>`).join('');
}

export const EMPTY_ASSISTANT_HTML = '<p>Je n’ai pas trouvé ces données dans la boutique.</p>';

export function isBlankAssistantHtml(input: string): boolean {
  const text = String(input || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/[.…·•\s]/g, '');
  return !text;
}

export function visibleAssistantHtml(input: string): string {
  const html = assistantHtml(input);
  return isBlankAssistantHtml(html) ? EMPTY_ASSISTANT_HTML : html;
}
